import { render, staticRenderFns } from "./ProductTypeSawlineEditPage.vue?vue&type=template&id=21686ba8"
import script from "./ProductTypeSawlineEditPage.vue?vue&type=script&lang=js"
export * from "./ProductTypeSawlineEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports